module.exports = __webpack_public_path__ + "static/media/Python.ef8a3a64.svg";